// extracted by mini-css-extract-plugin
export default {"tasks":"KN-z","task":"LN-z","svg":"MN-z","text":"NN-z"};